enum MediaItemType {
  Image = 1,
  Video,
}

export default MediaItemType;
